import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  Subject,
  switchMap,
  takeUntil,
  tap,
  timer,
  Observable,
  throwError
} from 'rxjs';
import { environment } from '../../../../environments/environment';

interface TokenResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number; // в секундах
  token_type: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  
  private api = environment.apiAuth;

  private token$ = new BehaviorSubject<string | null>(null);
  private stopRefresh$ = new Subject<void>();

  private refreshSubject = new BehaviorSubject<string | null>(null);

  constructor(private http: HttpClient) {}

  /** Сохраняем токены и запускаем автообновление */
  setSession(tokenRes: TokenResponse) {
    const { access_token, refresh_token, expires_in } = tokenRes;

    // console.log('SET SESSION', tokenRes);
    // сохраняем токены в localStorage
    // можно зашифровать их перед сохранением
    // https://www.npmjs.com/package/crypto-js
    localStorage.setItem('access_token', access_token);
    localStorage.setItem('refresh_token', refresh_token);

    this.token$.next(access_token);

    // уведомим всех подписчиков, что появился новый access
    this.refreshSubject.next(access_token);

    // сбрасываем старый таймер автообновления
    this.stopRefresh$.next();

    // автообновление за минуту до истечения
    timer((expires_in - 60) * 1000).pipe(
      takeUntil(this.stopRefresh$),
      switchMap(() => this.refreshToken(refresh_token))
    ).subscribe();
  }

  /** Обновление токена вручную */
  refreshToken(refresh: string): Observable<TokenResponse> {
    if (!refresh) {
      return throwError(() => new Error('No refresh token'));
    }

    return this.http.post<TokenResponse>(`${this.api}/refresh`, {
      refresh_token: refresh
    }).pipe(
      tap(res => this.setSession(res))
    );
  }

  /** Текущий access для интерсептора */
  getAccessToken(): string | null {
    return this.token$.value ?? localStorage.getItem('access_token');
  }

  /** Подписка, чтобы интерсептор ждал новый access */
  onTokenRefreshed(): Observable<string | null> {
    return this.refreshSubject.asObservable();
  }

  /** Выход */
  logout() {
    this.stopRefresh$.next();
    this.token$.next(null);
    this.refreshSubject.next(null);

    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }

  
}
